function hashId(id) {
  var s = String(id);
  var h = 0;
  for (var i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getCardLayout(tributeId, index) {
  var seed = hashId(tributeId) * 7 + index * 3;
  var rotation = ((seed % 7) - 3) * 0.8;
  var offsetX = ((seed % 5) - 2) * 3;
  var offsetY = ((seed % 4) - 1.5) * 3;
  var widthPct = 88 + (seed % 13);
  var justifySelf = seed % 3 === 0 ? "start" : seed % 3 === 1 ? "end" : "center";
  return { seed, rotation, offsetX, offsetY, widthPct, justifySelf };
}
